module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "d-inline-block bg-lighter radius-normal mr-3 image"
  }, [(_vm.image) ? _c('img', {
    attrs: {
      "src": _vm.image
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "timeline"
  }, [_vm._v("\n            " + _vm._s(_vm._f("moment")(_vm.event.start, 'dddd')) + ", " + _vm._s(_vm._f("moment")(_vm.event.start, 'HH:mm')) + " - " + _vm._s(_vm._f("moment")(_vm.event.end, 'HH:mm')) + "\n        ")]), _vm._v(" "), _c('h4', {
    staticClass: "bold mt-1 mb-3"
  }, [_vm._v("\n            " + _vm._s(_vm.product.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "fs-small"
  }, [_c('div', {
    staticClass: "available"
  }, [_vm._v("\n                Available:\n\n                "), _c('span', {
    class: (_vm.event.quantityAvailable < 3) ? 'color-6 bold' : ''
  }, [_vm._v("\n                    " + _vm._s(_vm.event.quantityAvailable) + "/" + _vm._s(_vm.event.maximumLotation) + "\n                ")])]), _vm._v(" "), _c('ul', _vm._l((_vm.event.eventNotes), function(note) {
    return (_vm.event.eventNotes.length > 0) ? _c('li', {
      staticClass: "d-flex align-items-center my-1"
    }, [_c('i', {
      staticClass: "ico-alert largest color-6"
    }), _vm._v("\n                    " + _vm._s(note.note) + "\n                ")]) : _vm._e()
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "logo p-4 bg-lighter"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-966bb9b0"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/Event.vue
// module id = 1545
// module chunks = 0